import {TweenMax, Power3} from "gsap";
import {Move} from "src/modules/helper/move/move";

export interface StickySidebarInterface {
  stickyElement: JQuery<HTMLElement>;
  startPosition?: number;
  endElement?: JQuery<HTMLElement>;
  headerElement?: JQuery<HTMLElement>;

  offsetTop?: number;
  endTrigger?: number | JQuery<HTMLElement>;
  visibleElement?: JQuery<HTMLElement>;
}

export interface StickySidebarInterfaceIterable {
  stickyElement: JQuery<HTMLElement>;
  startElement?: JQuery<HTMLElement>;
  endElement?: JQuery<HTMLElement>;
  headerElement?: JQuery<HTMLElement>;

  offsetTop?: number;
  endTrigger?: number | JQuery<HTMLElement>;
  visibleElement?: JQuery<HTMLElement>;

  [key: string]: any;
}

export class StickySidebar {

  public defaultConfig: any = {
    startPosition: 0,
    endPosition: Number.POSITIVE_INFINITY,
    offsetTop: 0,
    endTrigger: 0
  };

  public config: any;

  public stickyElement: JQuery<HTMLElement>;
  public fakeStickyElement: JQuery<HTMLElement>;

  public visibleElement: JQuery<HTMLElement>;
  public endElement: JQuery<HTMLElement>;
  public headerElement: JQuery<HTMLElement>;
  public threshold: number = 3;

  public startPosition: number;
  public endPosition: number;
  public startTrigger: number;
  public endTrigger: number;
  public offsetTop: number;
  public visibleElementOverflow: number;


  public constructor(config: StickySidebarInterface) {
    this.setDefault(config);

    this.initParameters();
    this.createFakeSticky();

    this.updateConfig();
    this.updateSticky();

    this.enableEvents();
  }

  private createFakeSticky(){
    let $stickyParent = this.stickyElement.parent();
    this.fakeStickyElement = this.stickyElement.clone().addClass('FakeStickyElement');
    TweenMax.set(this.fakeStickyElement, { position: 'fixed', autoAlpha: 0});
    $stickyParent.append(this.fakeStickyElement);
  }

  public disable() {
    $(window).off('resize.sticky scroll.sticky orientationchange.sticky');
    this.unstickUp();
  }

  public unstickUp() {
    TweenMax.set(this.stickyElement, {y: 0, autoAlpha: 1});
    TweenMax.set(this.fakeStickyElement, {autoAlpha: 0, top: 'auto', bottom: 'auto'});
    this.showReal();
  }

  public stickWindowsUp() {
    TweenMax.set(this.stickyElement, {y: this.startTrigger - this.startPosition + this.threshold, autoAlpha: 0});
    TweenMax.set(this.fakeStickyElement, {autoAlpha: 1, top: 0, bottom: 'auto'});
  }

  public stickWindowDown() {
    TweenMax.set(this.stickyElement, {
      y: $(window).scrollTop() + $(window).height() - this.visibleElement.box().height - this.startPosition - this.threshold,
      autoAlpha: 0
    });
    TweenMax.set(this.fakeStickyElement, {autoAlpha: 1, top: 'auto', bottom: 0});
  }

  public unstickDown() {
    TweenMax.set(this.stickyElement, {
      y: this.endPosition - this.startPosition - this.visibleElement.box().height - this.threshold,
      autoAlpha: 1
    });
    TweenMax.set(this.fakeStickyElement, {autoAlpha: 0, top: 'auto', bottom: 'auto'});
  }

  public showReal() {
    TweenMax.set(this.stickyElement, {autoAlpha: 1});
    TweenMax.set(this.fakeStickyElement, {autoAlpha: 0, top: 'auto', bottom: 'auto'});
  }

  private initParameters() {
    this.stickyElement = this.config.stickyElement;
    if (typeof this.config.visibleElement === 'undefined') {
      this.visibleElement = this.config.stickyElement;
    }
    else {
      this.visibleElement = this.config.visibleElement;
    }

    this.endElement = this.config.endElement;
    this.headerElement = this.config.headerElement;
    this.startPosition = this.config.startPosition;
    this.endPosition = this.config.endPosition;
    this.offsetTop = this.config.offsetTop;
  }

  private enableEvents() {
    $(window).off('resize.sticky scroll.sticky orientationchange.sticky');
    $(window).on('resize.sticky scroll.sticky orientationchange.sticky', () => {
      this.updateConfig();
      this.updateSticky();
    });
  }

  private updateSticky() {

    // Si l'element en sticky n'est pas visible sur toute la hauteur de la fenêtre
    if (this.visibleElement.box().height > $(window).height() - this.offsetTop) {

      // Le comportement est différent selon si on scroll vers en bas ou vers en haut
      if (Move.scroll.direction === 'down') {
        if (this.startTrigger - this.visibleElementOverflow < this.startPosition) {
          this.unstickUp();
        }
        else if (
          this.startTrigger - this.visibleElementOverflow >= this.startPosition &&
          this.startTrigger - this.visibleElementOverflow < this.endTrigger &&
          this.visibleElement.box().bottom < $(window).height()
        ) {
          this.stickWindowDown();
        }
        else if (this.endPosition) {
          if (this.startTrigger - this.visibleElementOverflow >= this.endTrigger) {
            this.unstickDown();
          }
          else {
            this.showReal();
          }
        }
      }

      else if (Move.scroll.direction === 'up') {
        if (this.startTrigger < this.startPosition) {
          this.unstickUp();
        }
        else if (
          this.startTrigger >= this.startPosition &&
          this.startTrigger - this.visibleElementOverflow < this.endTrigger &&
          this.visibleElement.box().top > this.offsetTop
        ) {
          this.stickWindowsUp();
        }
        else if (this.endPosition) {
          if (this.startTrigger - this.visibleElementOverflow >= this.endTrigger) {
            this.unstickDown();
          }
          else {
            this.showReal();
          }
        }
      }
    }

    // Si l'element en sticky est visible sur toute la hauteur de la fenêtre
    else {

      if (this.startTrigger < this.startPosition) {
        this.unstickUp();
      }
      else if (
        this.startTrigger >= this.startPosition &&
        this.startTrigger < this.endTrigger
      ) {
        this.stickWindowsUp();
      }
      else if (this.endPosition) {
        if (this.startTrigger >= this.endTrigger) {
          this.unstickDown();
        }
      }
    }

  }

  private updateConfig() {
    // Récupération de la position de fin
    if (typeof this.endElement !== 'undefined') {
      this.endPosition = this.endElement.offset().top;
    }

    // Récupération de la position de debut
    if (typeof this.headerElement !== 'undefined') {
      this.offsetTop = this.headerElement.box().height;
    }

    this.startTrigger = $(window).scrollTop() + this.offsetTop;
    this.endTrigger = this.endPosition - this.visibleElement.box().height;

    this.visibleElementOverflow = this.visibleElement.box().height - ($(window).height() - this.offsetTop);
  }

  private setDefault(config: StickySidebarInterface) {

    this.config = config;

    for (const key in this.defaultConfig) {
      if (typeof this.config[key] === 'undefined') {
        this.config[key] = this.defaultConfig[key]
      }
    }
  }


}